import produce from 'immer'
import { cloneDeep } from 'lodash'
import { getType } from 'typesafe-actions'
import * as actions from './actions'
import { State, Action } from './types'
import { initEvent, initMeta } from 'Store/common/common.reducer'
import parseErrorMessage from 'helpers/parseErrorMessage'
import { convertMetaData } from 'Store/common/common.function'

const initialState: State = {
  list: {
    data: [],
    meta: cloneDeep(initMeta),
  },
  listEvent: cloneDeep(initEvent),
  actionEvent: cloneDeep(initEvent),
  detail: undefined,
  detailEvent: cloneDeep(initEvent),
  partnerData: [],
  partnerCodes: {
    channel_code: [],
    industry_code: [],
  },
  partnerProfile: undefined,
  scanQrDashboard: {
    data: undefined,
    event: cloneDeep(initEvent),
  },
  caseDashboard: {
    data: undefined,
    event: cloneDeep(initEvent),
  },
}

export default function(state: State = initialState, action: Action) {
  return produce(state, draft => {
    let response
    switch (action.type) {
      case getType(actions.getListAction.request):
        draft.listEvent = cloneDeep(initEvent)
        draft.listEvent.IsLoading = true
        draft.list = {
          data: [],
          meta: cloneDeep(initMeta),
        }
        return draft
      case getType(actions.getListAction.success):
        response = action.payload
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitSuccess = true
        draft.list.data = response.data
        if (response.meta) {
          draft.list.meta = convertMetaData(response.meta)
        }
        return draft
      case getType(actions.getListAction.failure):
        draft.listEvent.IsLoading = false
        draft.listEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.getDetailAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.detail = undefined
        return draft
      case getType(actions.getDetailAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.detail = response.data
        return draft
      case getType(actions.getDetailAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.createAction.request):
      case getType(actions.updateQrPartnerStatusAction.request):
      case getType(actions.updateAction.request):
      case getType(actions.updateQrPartnerImageAction.request):
        draft.actionEvent = cloneDeep(initEvent)
        draft.actionEvent.IsLoading = true
        return draft
      case getType(actions.updateQrPartnerStatusAction.success):
      case getType(actions.updateAction.success):
      case getType(actions.createAction.success):
      case getType(actions.updateQrPartnerImageAction.success):
        response = action.payload
        if (response?.status.code === 200) {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = undefined
          draft.actionEvent.SubmitSuccess = true
          draft.actionEvent.MessageSuccess = 'บันทึกข้อมูลสำเร็จ'
        } else {
          draft.actionEvent.IsLoading = false
          draft.actionEvent.SubmitError = response?.message
        }

        return draft
      case getType(actions.updateQrPartnerStatusAction.failure):
      case getType(actions.updateAction.failure):
      case getType(actions.createAction.failure):
      case getType(actions.updateQrPartnerImageAction.failure):
        draft.actionEvent.IsLoading = false
        draft.actionEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getPartnerStructerAction.request):
        draft.partnerData = []
        return draft
      case getType(actions.getPartnerStructerAction.success):
        response = action.payload
        draft.partnerData = response.data
        return draft
      case getType(actions.getPartnerCodeAction.request):
        draft.partnerCodes = {
          channel_code: [],
          industry_code: [],
        }
        return draft
      case getType(actions.getPartnerCodeAction.success):
        response = action.payload
        draft.partnerCodes = response.data
        return draft
      case getType(actions.getPartnerInfoAction.request):
        draft.partnerInfo = undefined
        return draft
      case getType(actions.getPartnerInfoAction.success):
        response = action.payload
        draft.partnerInfo = response.data
        return draft

      case getType(actions.getPartnerProfileAction.request):
        draft.detailEvent = cloneDeep(initEvent)
        draft.detailEvent.IsLoading = true
        draft.partnerProfile = undefined
        return draft
      case getType(actions.getPartnerProfileAction.success):
        response = action.payload
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitSuccess = true
        draft.partnerProfile = response.data
        return draft
      case getType(actions.getPartnerProfileAction.failure):
        draft.detailEvent.IsLoading = false
        draft.detailEvent.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getPartnerScanQrDashboardAction.request):
        draft.scanQrDashboard.event = cloneDeep(initEvent)
        draft.scanQrDashboard.event.IsLoading = true
        draft.scanQrDashboard.data = {
          all: {
            countAll: 0,
            countAssigned: 0,
            countEndCase: 0,
            countNotAssign: 0,
          },
          self: {
            countAll: 0,
            countAssigned: 0,
            countEndCase: 0,
            countNotAssign: 0,
          },
          team: {
            countAll: 0,
            countAssigned: 0,
            countEndCase: 0,
            countNotAssign: 0,
          },
        }
        return draft
      case getType(actions.getPartnerScanQrDashboardAction.success):
        response = action.payload
        draft.scanQrDashboard.event.IsLoading = false
        draft.scanQrDashboard.event.SubmitSuccess = true
        draft.scanQrDashboard.data = response.count
        return draft
      case getType(actions.getPartnerScanQrDashboardAction.failure):
        draft.scanQrDashboard.event.IsLoading = false
        draft.scanQrDashboard.event.SubmitError = parseErrorMessage(action.payload)
        return draft

      case getType(actions.getPartnerQrCaseDashboardAction.request):
        draft.caseDashboard.event = cloneDeep(initEvent)
        draft.caseDashboard.event.IsLoading = true
        draft.caseDashboard.data = undefined
        return draft
      case getType(actions.getPartnerQrCaseDashboardAction.success):
        response = action.payload
        draft.caseDashboard.event.IsLoading = false
        draft.caseDashboard.event.SubmitSuccess = true
        draft.caseDashboard.data = response.data
        return draft
      case getType(actions.getPartnerQrCaseDashboardAction.failure):
        draft.caseDashboard.event.IsLoading = false
        draft.caseDashboard.event.SubmitError = parseErrorMessage(action.payload)
        return draft
      case getType(actions.clearEventAction):
        draft.listEvent = cloneDeep(initEvent)
        draft.actionEvent = cloneDeep(initEvent)
        draft.scanQrDashboard.event = cloneDeep(initEvent)
        draft.caseDashboard.event = cloneDeep(initEvent)
        return draft

      default:
        return state
    }
  })
}
